export default __webpack_public_path__ + "static/media/minusIcon.aa1f7052.svg";